export default __webpack_public_path__ + "static/media/edit.0f21da73.svg";